import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { TextTrack } from '../types/instance';

export const useTextTracks = () => {
    const instance = usePlayerInstance();
    const [textTracks, setTextTracks] = useState<ReadonlyArray<TextTrack> | undefined>(
        () => instance?.textTracks
    );

    useInstanceEffect((instance) => instance.onTextTracksChange(setTextTracks));

    return textTracks;
};
